import * as Sentry from '@sentry/node';
import { Resource } from 'services/hitchit/types/hike/Resource';

{
  /* https://app.teamleader.eu/contact_detail.php?id= */
}
//   href={`https://app.teamleader.eu/sale_detail.php?id=${teamleaderDealResource.id}`}

function logException(hitch: string, resource: Resource): string {
  const errorMsg = `createHitchUrl for hitch ${hitch} - resource ${resource.resource} not yet supported`;
  console.error(errorMsg);
  Sentry.captureException(errorMsg);
  return '';
}
function createHitchUrlForTeamLeader(hitch: string, resource: Resource): string {
  switch (resource.resource) {
    case 'deal':
      return `https://app.teamleader.eu/sale_detail.php?id=${resource.id}`;
    case 'contact':
      return `https://app.teamleader.eu/contact_detail.php?id=${resource.id}`;
    case 'company':
      return `https://app.teamleader.eu/company_detail.php?id=${resource.id}`;
    default: {
      return logException(hitch, resource);
    }
  }
}

export default function createHitchUrl(hitch: string, resource: Resource): string {
  if (resource.url) {
    return resource.url;
  }
  // This part is DEPRECATED; the idea is that the url is inserted in the backend
  switch (hitch) {
    case 'teamleader':
      return createHitchUrlForTeamLeader(hitch, resource);
    default: {
      return logException(hitch, resource);
    }
  }
}
